export default __webpack_public_path__ + "static/media/24.417a5caa.jpg";